import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Breadcrumbs from './components/Breadcrumbs';
import PageHeader from './components/PageHeader';
import Footer from './components/Footer';
// import Home from './pages/Home';
// import Portfolio from './pages/Portfolio';
import NewHome from './pages/NewHome';
import NewPortfolio from './pages/newPortfolio';
import InvestmentCriteria from './pages/InvestmentCriteria';
import CompanyInformation from './pages/CompanyInformation';
import InvestmentPhilosophy from './pages/InvestmentPhilosophy';
import Careers from './pages/Careers';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Disclaimer from './pages/Disclaimer';
import CookiePolicy from './pages/CookiePolicy';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="app">
          <Navbar />
          <Breadcrumbs />
          <PageHeader />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<NewHome />} />
              <Route path="/portfolio" element={<NewPortfolio />} />
              <Route path="/investment-criteria" element={<InvestmentCriteria />} />
              <Route path="/company-information" element={<CompanyInformation />} />
              <Route path="/investment-philosophy" element={<InvestmentPhilosophy />} />
              <Route path="/careers" element={<Careers />} />
              {/* <Route path="/" element={<Home />} />
              <Route path="/portfolio" element={<Portfolio />} /> */}
              <Route path="/newhome" element={<NewHome />} />
              <Route path="/newportfolio" element={<NewPortfolio />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
